import { ArrowDown, ArrowUp, Minus } from "lucide-react";

// Variação percentual entre dois números; null quando não dá pra comparar (base zero).
export const percentChange = (current, previous) => {
  if (!previous) return current ? null : 0;
  return ((current - previous) / previous) * 100;
};

const Trend = ({ value, label, invert = false }) => {
  if (value === undefined) return label ? <p className="truncate text-xs text-gray-500">{label}</p> : null;
  const isNull = value === null;
  const up = !isNull && value > 0;
  const flat = !isNull && Math.round(value) === 0;
  const good = invert ? !up : up;
  const tone = isNull || flat ? 'bg-gray-200 text-gray-500' : good ? 'bg-emerald-500 text-white' : 'bg-rose-500 text-white';
  const text = isNull || flat ? 'text-gray-500' : good ? 'text-emerald-600' : 'text-rose-600';
  const Icon = isNull || flat ? Minus : up ? ArrowUp : ArrowDown;
  return (
    <div className="flex min-w-0 items-center gap-1.5 text-xs">
      <span className={`flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full ${tone}`}>
        <Icon className="h-2.5 w-2.5" strokeWidth={3} />
      </span>
      <span className={`font-semibold ${text}`}>
        {isNull ? 'novo' : `${value > 0 ? '+' : ''}${value.toFixed(Math.abs(value) < 10 ? 1 : 0)}%`}
      </span>
      {label && <span className="truncate text-gray-500">{label}</span>}
    </div>
  );
};

// Tile de número no estilo da referência: rótulo com ícone em cima, caixa suave com o valor
// grande e a tendência embaixo. `trend` = variação em % (ou null = sem base de comparação);
// sem `trend`, só mostra o `caption`.
export const StatTile = ({ icon: Icon, label, value, trend, caption, invertTrend, onClick, active }) => {
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`flex min-w-0 flex-col rounded-xl border bg-white p-1.5 text-left transition ${
        active ? 'border-accent/40 ring-2 ring-accent/15' : 'border-gray-200/80'
      } ${onClick ? 'hover:border-gray-300 hover:shadow-card' : ''}`}
    >
      <div className="flex items-center gap-2 px-2 pb-2.5 pt-1.5">
        <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-gray-200 text-gray-500">
          <Icon className="h-3.5 w-3.5" />
        </span>
        <span className="truncate text-[13px] text-gray-500">{label}</span>
      </div>
      <div className="flex flex-1 flex-col gap-2 rounded-lg bg-subtle px-3 py-3">
        <p className="tabular truncate text-2xl font-semibold tracking-tight text-gray-900">{value}</p>
        <Trend value={trend} label={caption} invert={invertTrend} />
      </div>
    </Tag>
  );
};
